"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_69_13_0 = void 0;
/**
 * Migrate to 69.13.0
 *
 * delete mounting on Zugentlastung if -1
 *
 */
const migration_69_13_0 = (json) => {
    if (json.Zugentlastungen) {
        json.Zugentlastungen.forEach((zugentlastungJson) => {
            if (zugentlastungJson.Mounting === -1)
                delete zugentlastungJson.Mounting;
        });
    }
    return json;
};
exports.migration_69_13_0 = migration_69_13_0;
//# sourceMappingURL=migration_69_13_0.js.map